<script lang="ts">
  import { X } from 'lucide-svelte';
  import type { Snippet } from 'svelte';
  import { palette } from '$lib/state/palette.svelte';

  const {
    title,
    onClose,
    children,
    footer,
    wide = false
  }: { title: string; onClose: () => void; children: Snippet; footer?: Snippet; wide?: boolean } = $props();

  // Esc priority is palette -> modal (design pack §4) — if the command
  // palette is open (it renders above the modal, z-70 vs z-60), this Esc
  // press is its to consume; don't also close the modal underneath.
  function onKeydown(e: KeyboardEvent) {
    if (e.key === 'Escape' && !palette.open) onClose();
  }
</script>

<svelte:window onkeydown={onKeydown} />

<!-- svelte-ignore a11y_click_events_have_key_events -->
<!-- svelte-ignore a11y_no_static_element_interactions -->
<div class="modal-overlay" role="presentation" onclick={onClose}>
  <div class="modal {wide ? 'wide' : ''}" role="dialog" aria-modal="true" tabindex="-1" onclick={(e) => e.stopPropagation()}>
    <div class="modal-h">
      <span class="mt">{title}</span>
      <span style="flex:1"></span>
      <button type="button" class="icon-btn" onclick={onClose} aria-label="Close"><X size={18} /></button>
    </div>
    <div class="modal-b">
      {@render children()}
    </div>
    {#if footer}
      <div class="modal-f">
        {@render footer()}
      </div>
    {/if}
  </div>
</div>
